const trendingItems = [
  {
    type: 'Sneakers',
    desc: 'Premium athletic footwear comparison sheet',
    price: '$89',
    imageUrl: 'https://readdy.ai/api/search-image?query=Single%20premium%20running%20shoe%20standing%20on%20reflective%20black%20obsidian%20surface%20with%20cool%20blue%20rim%20light%2C%20high%20contrast%20product%20photography%20with%20dramatic%20studio%20lighting%20and%20futuristic%20tech%20editorial%20aesthetic&width=400&height=400&seq=trend-sneakers-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    type: 'Hoodies',
    desc: 'Streetwear essentials spreadsheet 2026',
    price: '$54',
    imageUrl: 'https://readdy.ai/api/search-image?query=Charcoal%20grey%20heavyweight%20hoodie%20partially%20unfolded%20on%20raw%20concrete%20block%20with%20spray%20paint%20can%20nearby%2C%20gritty%20urban%20street%20art%20atmosphere%20with%20dappled%20sunlight%20through%20chain%20link%20fence%2C%20raw%20editorial%20streetwear%20photography&width=400&height=400&seq=trend-hoodies-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    type: 'T-Shirts',
    desc: 'Best budget tee comparison table',
    price: '$29',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20three%20colorful%20basic%20t-shirts%20in%20navy%20olive%20and%20burgundy%20folded%20on%20weathered%20wooden%20pallet%20with%20rope%20texture%2C%20coastal%20beach%20house%20vibe%20with%20natural%20sun%20bleached%20lighting%20editorial%20casual%20fashion%20photography&width=400&height=400&seq=trend-tshirts-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    type: 'Jackets',
    desc: 'Lightweight jacket sourcing guide',
    price: '$112',
    imageUrl: 'https://readdy.ai/api/search-image?query=Tan%20windbreaker%20jacket%20hanging%20on%20weathered%20driftwood%20branch%20against%20misty%20foggy%20forest%20background%2C%20outdoor%20adventure%20gear%20photography%20with%20moody%20atmospheric%20lighting%20and%20earthy%20natural%20palette%20editorial%20style&width=400&height=400&seq=trend-jackets-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    type: 'Accessories',
    desc: 'Watch and jewelry deals sheet',
    price: '$67',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20silver%20watch%20on%20black%20slate%20stone%20next%20to%20small%20copper%20geometric%20sculpture%2C%20contemporary%20art%20gallery%20display%20with%20sharp%20directional%20spotlight%2C%20high%20contrast%20monochrome%20and%20metallic%20editorial%20product%20photography&width=400&height=400&seq=trend-accessories-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    type: 'Bags',
    desc: 'Backpack and bag price tracker',
    price: '$78',
    imageUrl: 'https://readdy.ai/api/search-image?query=Olive%20green%20canvas%20backpack%20leaning%20against%20rustic%20stone%20wall%20with%20wild%20lavender%20growing%20beside%20it%2C%20Provence%20countryside%20atmosphere%20with%20soft%20diffused%20natural%20light%2C%20travel%20lifestyle%20editorial%20photography%20with%20warm%20organic%20tones&width=400&height=400&seq=trend-bags-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    type: 'Jersey',
    desc: 'Sports jersey price comparison',
    price: '$64',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bold%20team%20jersey%20hanging%20from%20locker%20room%20hook%20with%20gym%20towel%20and%20water%20bottle%20on%20bench%20below%2C%20dramatic%20overhead%20court%20lighting%20casting%20strong%20geometric%20shadows%2C%20professional%20sports%20editorial%20photography%20with%20raw%20energy&width=400&height=400&seq=trend-jersey-v3&orientation=squarish',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
];

export default function TrendingSection() {
  return (
    <section id="trending" className="py-16 md:py-24 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-accent-600 font-semibold text-sm mb-2">Trending Now</p>
            <h2 className="text-3xl md:text-5xl font-extrabold text-foreground-950 leading-[1.1] tracking-tight">
              Hot Deals &amp; Popular Sheets
            </h2>
            <p className="text-foreground-500 text-sm mt-3">Updated daily from global sources</p>
          </div>
          <span className="hidden md:inline-block px-4 py-2 rounded-full bg-foreground-950 text-white text-xs font-semibold whitespace-nowrap">
            Hot Deals
          </span>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-6 md:-mx-10 lg:-mx-16 px-6 md:px-10 lg:px-16 scrollbar-hide">
          {trendingItems.map((item) => (
            <a
              key={item.type}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-64 bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.type + ' pandabuy spreadsheet trending'}
                  className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 mb-1">{item.type}</p>
                <p className="text-sm text-foreground-700 leading-snug mb-3">{item.desc}</p>
                <span className="text-xl font-extrabold text-foreground-950">{item.price}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}